import React from 'react';
import PreviewQuestionShell from './PreviewQuestionShell';

const DropdownQuestionBlock = ({ question, register, errors }) => (
    <PreviewQuestionShell question={question} error={errors[question.internalId]?.message}>
        <select
            className="form-select form-select-sm"
            {...register(question.internalId, {
                required: question.required ? `${question.title} is required` : false,
            })}
        >
            <option value="">{question.placeholder || 'Select an option'}</option>
            {question.options?.map((opt) => (
                <option key={opt.id} value={opt.value}>
                    {opt.text}
                </option>
            ))}
        </select>
    </PreviewQuestionShell>
);

export default DropdownQuestionBlock;
